/*
 * InputNumber
 */
import RooInputNumber from './InputNumber';
export * from './interface';
export default RooInputNumber;